import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import logo from "../../secondAssets/Images/logo.png"
import { VscThreeBars } from "react-icons/vsc";
import { IoMdClose } from "react-icons/io";
import allPaths from '../../Config/paths'
import { menuItems } from "../../secondUtils/constants";
import { FaPlus, FaMinus } from "react-icons/fa6";
import { useDispatch } from 'react-redux'
import EnglishFlag from '../../assets/Images/englishFlag.png'
import GermanLanguage from '../../assets/Images/germanLangugae.png'
import ArabicLanguage from '../../assets/Images/arabicLanguage.jpg'
import { setLanguage } from "../../Redux/actions/languageAction";

const Header = (props) => {
    const [isHeaderFixed, setIsHeaderFixed] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);
    const [activeSubmenus, setActiveSubmenus] = useState({});
    const history = useHistory();
    const dispatch = useDispatch()
    const location = useLocation()
    const { language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'

    const changeLanguage = (language) => {
        dispatch(setLanguage(language));
    }
    // useEffect(() => {
    //     const handleScroll = () => {
    //         setIsHeaderFixed(window.scrollY > window.innerHeight);
    //     };
    //     window.addEventListener('scroll', handleScroll);
    //     return () => window.removeEventListener('scroll', handleScroll);
    // }, []);

    const handleNavigation = (path) => {
        history.push(path);
    };
    const toggleMobileSubmenu = (menuName) => {
        setActiveSubmenus(prev => ({
            ...prev,
            [menuName]: !prev[menuName]
        }));
    };

    return (
        <div className={`header-main ${isHeaderFixed ? 'fixed' : ''}`}>
            <div className="second-design-header">
                <div className="second-design-header-inner-div">
                    <div className="second-design-header-logo-div">
                        <img onClick={() => handleNavigation(allPaths?.SECONDHOME)} src={logo} alt="" />
                        {toggle ? (
                            <nav className="second-desig-navbar mobile-navbar">
                                <ul>
                                    {menuItems.map((item, index) => (
                                        <div key={index}>
                                            <div className={location?.pathname === item?.menuRoute ? "active-menu second-design-mobile-menu" : "second-design-mobile-menu"}>
                                                <li onClick={() => handleNavigation(item.menuRoute)}>
                                                    <a>{isELSelect ? item?.menuName : (isAlSelect ? item?.menuALName : item?.menuGLName)}</a>
                                                </li>
                                                {item.submenu ? (
                                                    <button className="sub-menu-btn" onClick={() => toggleMobileSubmenu(item.menuName)}>
                                                        {activeSubmenus[item?.menuName] ? <FaMinus /> : <FaPlus />}
                                                    </button>
                                                ) : null}
                                            </div>
                                            {
                                                activeSubmenus[item?.menuName] && item?.submenu ? (
                                                    item.submenu.map((sub, i) => (
                                                        <li className="mobile-sub-menu" key={i}>
                                                            <a href="#" onClick={(e) => {
                                                                e.preventDefault();
                                                                handleNavigation(sub?.route);
                                                            }}>
                                                                {isELSelect ? sub?.name : (isAlSelect ? sub?.alName : sub?.glName)}
                                                            </a>
                                                        </li>
                                                    ))
                                                ) : null
                                            }
                                        </div>
                                    ))}
                                </ul>
                                <span onClick={() => changeLanguage('english')} >
                                    <img src={EnglishFlag} className="LanguageChange" />
                                </span>
                                <span onClick={() => changeLanguage('arabic')}>
                                    <img src={ArabicLanguage} className="arabicLanguage" />
                                </span>
                                <span onClick={() => changeLanguage('german')}>
                                    <img src={GermanLanguage} className="LanguageChange" />
                                </span>
                            </nav>
                        ) : null}
                    </div>
                    <div>
                        <nav className="second-desig-navbar">
                            <ul>
                                {menuItems.map((item, index) => (
                                    <li key={index}
                                        className={location?.pathname === item?.menuRoute ? "active-menu" : ""}
                                        onMouseEnter={() => setHoveredItem(item?.menuName)}
                                        onMouseLeave={() => setHoveredItem(null)}
                                        onClick={() => handleNavigation(item?.menuRoute)}
                                    >
                                        <a href="" onClick={(e) => e.preventDefault()}>
                                            {isELSelect ? item?.menuName : (isAlSelect ? item?.menuALName : item?.menuGLName)}
                                        </a>
                                        {hoveredItem === item?.menuName && item?.submenu ? (
                                            <div className="submenu">
                                                {item?.submenu.map((sub, i) => (
                                                    <a key={i} href="" onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        handleNavigation(sub.route);
                                                    }}>
                                                        {isELSelect ? sub?.name : (isAlSelect ? sub?.alName : sub?.glName)}
                                                    </a>
                                                ))}
                                            </div>
                                        ) : null}
                                    </li>
                                ))}
                            </ul>
                            <span onClick={() => changeLanguage('english')} >
                                <img src={EnglishFlag} className="LanguageChange" />
                            </span>
                            <span onClick={() => changeLanguage('arabic')}>
                                <img src={ArabicLanguage} className="arabicLanguage" />
                            </span>
                            <span onClick={() => changeLanguage('german')}>
                                <img src={GermanLanguage} className="LanguageChange" />
                            </span>
                        </nav>
                    </div>
                    <div className="second-design-toggle-btn" onClick={() => setToggle(!toggle)}>
                        {toggle ? <IoMdClose /> : <VscThreeBars />}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Header;
